var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resizeObserver",rawName:"v-resizeObserver",value:({
    openResize: true,
    handler: _vm.observerCallBack
  }),expression:"{\n    openResize: true,\n    handler: observerCallBack\n  }"}],style:({ overflow: 'hidden' })},[_c('div',{attrs:{"id":"metricChart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }